export const itemsLabel = "QFnkfe";
export const itemsTooltip = "jNqFW";
export const unreadLabel = "F5R0eb";
export const unreadTooltip = "ykGOcd";
export default {itemsLabel,itemsTooltip,unreadLabel,unreadTooltip};